import './index.scss'
// 20230630
let mouseover_tid = [];
let mouseout_tid = [];
if ($(window).width() > 1024) {
  $(".header-aside .menu").each(function (index) {
    $(this).hover(
      // 榧犳爣杩涘叆
      function () {
        let _self = this;
        // 鍋滄鍗疯捣浜嬩欢
        clearTimeout(mouseout_tid[index]);
        // 褰撻紶鏍囪繘鍏ヨ秴杩 0.2 绉? 灞曞紑鑿滃崟, 骞惰褰曞埌绾跨▼ ID 涓璡r
        mouseover_tid[index] = setTimeout(function () {
          if ($(_self).hasClass('active')) {
            $(_self).on('click', function () {
              if ($(_self).hasClass('active')) {
                $(_self).removeClass('active')
                $('.header-nav').removeClass('show-nav')
              }
            })
          } else {
            $(_self).addClass('active')
            $('.header-nav').addClass('show-nav')
            setTimeout(function () {
              if ($(window).width() > 1024) {
                $(".header-nav .nav ul li").eq(1).addClass('pc-active')
              }
            }, 800)
          }
        }, 201);
      },
      // 榧犳爣绂诲紑
      function () {
        let _self = this;
        // 鍋滄灞曞紑浜嬩欢
        clearTimeout(mouseover_tid[index]);
        // 褰撻紶鏍囩寮€瓒呰繃 0.2 绉? 鍗疯捣鑿滃崟, 骞惰褰曞埌绾跨▼ ID 涓璡r
        mouseout_tid[index] = setTimeout(function () {
        }, 201);
      });
  });
} else {
  $('.header-aside .menu').on('click', function () {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active')
      $('.header-nav').removeClass('show-nav')
    } else {
      $(this).addClass('active')
      $('.header-nav').addClass('show-nav')
      setTimeout(function () {
        if ($(window).width() > 1024) {
          $(".header-nav .nav ul li").eq(1).addClass('pc-active')
        }
      }, 800)
    }
  })
}
// 20230630
$('.header-aside .back-top').on('click', function () {
  $("html, body").animate({
    scrollTop: 0
  }, {
    duration: 500,
    easing: "swing"
  });
  return false;
})

$('.header-nav .nav-search .open-search').on('click', function () {
  if ($('.header-nav .nav-search').hasClass('active')) {
    $('.header-nav .nav-search').removeClass('active')
    $('#header-search-input').blur()
  } else {
    $('.header-nav .nav-search').addClass('active')
    setTimeout(function () {
      $('#header-search-input').focus()
    }, 100)
  }
})


$('.header-nav .nav ul li .nav-title .iconfont').on('click', function () {
  let $parentsEL = $(this).parents('li')
  if ($parentsEL.hasClass('mob-active')) {
    $parentsEL.removeClass('mob-active').find('.sub-nav').slideUp()
  } else {
    $('.header-nav .nav ul li').removeClass('mob-active').find('.sub-nav').slideUp()
    $parentsEL.addClass('mob-active').find('.sub-nav').slideDown()
  }
})






//椤甸潰婊氬姩鐩戝惉
$(document).scroll(function () {
  var scroH = $(document).scrollTop(); //婊氬姩楂樺害
  var viewH = $(window).height(); //鍙楂樺害
  var contentH = $(document).height(); //鍐呭楂樺害

  if (scroH > viewH / 2) {
    $('.header-aside .btn-icon').addClass('scroll')
  } else {
    $('.header-aside .btn-icon').removeClass('scroll')
  }
});